export const NOTIFICATION_BADGE_CONFIG = {
  "FEATURED-MATCH": { backgroundColor: "#FACC15", color: "#230E2F" },
  "FEATURED-EVENT": { backgroundColor: "#FB923C", color: "#ffffff" },
  "NEW": { backgroundColor: "#34D399", color: "#230E2F" },
  "REMAINDER": { backgroundColor: "#38BDF8", color: "#230E2F" },
  "POPULAR": { backgroundColor: "#8B5CF6", color: "#ffffff" },
  "ALERT": { backgroundColor: "#EF4444", color: "#ffffff" },
};

export const formatBadgeLabel = (type) => {
  if (!type) return "";
  return String(type)
    .trim()
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
